import { useEffect, useRef } from "react";

import React, { useState } from "react";
import Paper from '../assets/paper.svg'
import Eth from '../assets/eth.svg'
import Usdt from '../assets/usdt.svg'
import Hero from '../assets/phone.png'
import { createWeb3Modal, defaultConfig } from '@web3modal/ethers/react'
import { useWeb3Modal } from '@web3modal/ethers/react'

import Web3 from 'web3';
import { useWeb3ModalProvider, useWeb3ModalAccount } from '@web3modal/ethers/react';
import { 
  usdtContractAddress, presaleContractAddress, 
  usdtContractABI, presaleContractAbi 
} from './config'; // Adjust the path as necessary
import Modal from "./modal";

let web3;
if (window.ethereum) {
    web3 = new Web3(window.ethereum);
    try {
        window.ethereum.enable().then(function() {
            // User has allowed account access to DApp...
        });
    } catch(e) {
        // User has denied account access to DApp...
    }
} 
// Or if the user is using an older web3 provider
else if (window.web3) {
    web3 = new Web3(window.web3.currentProvider);
} 
// If no injected web3 instance is detected, fall back to Ganache
else {
    web3 = new Web3(new Web3.providers.HttpProvider("http://localhost:7545"));
}

const projectId = '56b29597c06a541f23088666d46fa211'

// 2. Set chains
const mainnet = {
  chainId: 1,
  name: 'Ethereum',
  currency: 'ETH',
  explorerUrl: 'https://etherscan.io',
  rpcUrl: 'https://cloudflare-eth.com'
}
const sepolia = {
  chainId: 11155111,
  name: 'Sepolia',
  currency: 'ETH',
  explorerUrl: 'https://sepolia.etherscan.io',
  rpcUrl: 'https://sepolia.infura.io/v3/'
}

// 3. Create modal
const metadata = {
  name: 'My Website',
  description: 'My Website description',
  url: 'https://mywebsite.com', // origin must match your domain & subdomain
  icons: ['https://avatars.mywebsite.com/']
}

createWeb3Modal({
  ethersConfig: defaultConfig({
    metadata,
    defaultChainId: 11155111,
    enableEIP6963: true,
    enableInjected: true,
    enableCoinbase: true,
    rpcUrl: '...' // used for the Coinbase SDK
  }),
  chains: [sepolia],
  projectId,
  enableAnalytics: true // Optional - defaults to your Cloud configuration
})

const Container = () => {
  const { open } = useWeb3Modal()

  const { walletProvider } = useWeb3ModalProvider();
  const { address } = useWeb3ModalAccount();
  const [isWalletConnected, setIsWalletConnected] = useState(false);

  const usdtContract = new web3.eth.Contract(usdtContractABI, usdtContractAddress);

  const presaleContract = new web3.eth.Contract(presaleContractAbi, presaleContractAddress);

  const [timerDays, setTimerDays] = useState('00')
    const [timerHours, setTimerHours] = useState('00')
    const [timerMinutes, setTimerMinutes] = useState('00')
    const [timerSeconds, setTimerSeconds] = useState('00')

    const [paymentMethod, setPaymentMethod] = useState('ETH');
    const [output, setOutput] = useState('0');
    const [usdtAmount, setUsdtAmount] = useState('');
    const [ethAmount, setEthAmount] = useState('');
    const [isEth, setIsEth] = useState(true); // Default to true or false based on your initial choice
    const [showModal, setShowModal] = useState(false);
    const [transactionReceipt, setTransactionReceipt] = useState(null);

    const etherscanBaseUrl = 'https://etherscan.io/tx/';

    // Function to handle payment method change
    const handlePaymentMethodChange = (method) => {
      if (method === 'ETH') {
        setIsEth(true);
      } else {
        setIsEth(false);
      }
    };
    // Initialize Web3 and the contract instance...

    const handleUsdtAmountChange = (event) => {
        setUsdtAmount(event.target.value);
    };

    const handleEthAmountChange = (event) => {
        setEthAmount(event.target.value);
    };

    useEffect(() => {
      setIsWalletConnected(!!address);
    }, [address]);
  


    const toReceive = event => {
      if (paymentMethod === 'ETH') {
        handlePaymentMethodChange('ETH')
        const tokenToReceive = (event.target.value * 2200) / 0.02;
        setOutput(tokenToReceive)
        handleEthAmountChange(event)
      } else {
        handlePaymentMethodChange('USDT')
        const tokenToReceive = event.target.value / 0.02;
        setOutput(tokenToReceive)
        handleUsdtAmountChange(event)
      }
    }

    const toTokenDecimals = (amount, decimals = 6) => {
      return (amount * Math.pow(10, decimals)).toString();
  };

  const checkAndApproveAllowance = async (amount) => {
    const accounts = await web3.eth.getAccounts();
    const allowance = await usdtContract.methods.allowance(accounts[0], presaleContractAddress).call();
    const usdtAmount = web3.utils.toWei(amount, 'mwei'); // 'mwei' for 6 decimals
  
    if (new web3.utils.BN(allowance).lt(new web3.utils.BN(usdtAmount))) {
      // Approve the PresaleContract to spend the necessary amount of USDT
      return usdtContract.methods.approve(presaleContractAddress, usdtAmount)
        .send({ from: accounts[0] });
    }
  };
  
  const contributeUSDT = async () => {
    
      const accounts = await web3.eth.getAccounts();
      const amount = toTokenDecimals(usdtAmount);

      await checkAndApproveAllowance(usdtAmount);

      presaleContract.methods.contributeUSDT(amount)
          .send({ from: accounts[0] })
          .then((receipt) => {
              console.log(receipt);
              console.log('Transaction receipt:', receipt);

    // Create a response for the user
    const response = {
        transactionHash: receipt.transactionHash,
        blockNumber: receipt.blockNumber,
        gasUsed: receipt.gasUsed,
        status: receipt.status ? 'Success' : 'Fail',
        // Include any other details you want from the receipt
    };
    setTransactionReceipt(receipt);
            setShowModal(true);
            setTimeout(() => {
              setShowModal(false);
          }, 5000);

    // You can now return this response or display it in your UI
    return response;
          })
          .catch((error) => {
              console.error(error);
              // Handle errors here
          });
      
  }

  const contributeETH = async () =>  {
    const accounts = await web3.eth.getAccounts();
    const amount = web3.utils.toWei(ethAmount, 'ether');
console.log(amount)
    presaleContract.methods.contributeETH()
        .send({ from: accounts[0], value: amount })
        .then((receipt) => {
            console.log(receipt);
            console.log('Transaction receipt:', receipt);

            // Create a response for the user
            const response = {
                transactionHash: receipt.transactionHash,
                blockNumber: receipt.blockNumber,
                gasUsed: receipt.gasUsed,
                status: receipt.status ? 'Success' : 'Fail',
                // Include any other details you want from the receipt
            };
            setTransactionReceipt(receipt);
                    setShowModal(true);
                    setTimeout(() => {
                      setShowModal(false);
                  }, 5000);
        })
        .catch((error) => {
            console.error(error);
            // Handle errors here
        });
}

const buyToken = () => {
  if (paymentMethod === 'ETH') {
    console.log(ethAmount)
    contributeETH()
  } else {
    console.log(usdtAmount)
    contributeUSDT()
  }
}

    let interval = useRef();

    const startTimer = () => {
      const countdownDate = new Date('February 7 2024 11:20:00').getTime()

      interval = setInterval(() => {
        const now = new Date().getTime()
        const distance = countdownDate - now;

        const days = Math.floor(distance / (1000 * 60 * 60 * 24))
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)))
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
        const seconds = Math.floor((distance % (1000 * 60)) / 1000)


        if (distance < 0) {
              clearInterval(interval.current)
        }else {
          setTimerDays(days)
          setTimerHours(hours)
          setTimerMinutes(minutes)
          setTimerSeconds(seconds)
        }
      }, 1000)
    }



    useEffect(() => {
      startTimer()
      return () => {
        clearInterval(interval.current)
      }
    })

  return (
    <div className='ml-[7rem] md:mb-[5rem] sm:mb-[5rem] mt-[5rem] flex gap-[10rem] md:flex-col sm:gap-16 sm:flex-col sm:ml-3'>
     <div>
      <h1 className='font-[600] tracking-wide font-inter text-[54px] sm:text-[28px]'><span className='text-[#9C02EA] '>HumanizedAi</span> Presale</h1>
      <p className='font-[600] leading-8 font-inter text-[54px] sm:text-[25px]'>Feedback Data Hub<span className='bg-[#9C02EA] text-white px-3 mx-1 rounded-[47.25px]'>for Ai</span></p>
      <p className='leading-1 pt-12 font-inter tracking-wide w-[40rem] sm:text-[13px] sm:w-[100%]'>Own the token of the number #1 Humanized machine learning protocol, that connects Ai companies with millions of individual users who train Ai models within our framework and earn money for each feedback [Quanitify to Earn]. </p>
      
      <div className='flex  pt-6 gap-5 sm:gap-2'>
      <button className='text-white  font-inter px-8 py-3 rounded-[47.25px] bg-[#9C02EA]  sm:w-[20%] sm:h-[40px] sm:px-3 sm:text-[10px]'>Audit</button>
      
      <div className='text-white flex items-center justify-center gap-3 px-8 py-3 rounded-[47.25px] bg-[#000000]  sm:w-[35%] sm:h-[40px]  sm:text-[10px]'><p>Whitepaper</p> <img
        src={Paper}
        alt="image"
        className="w-3 h-5 object-cover"
      /></div>
      </div>
      <div className='sm:hidden md:hidden'> <img
        src={Hero}
        alt="image"
        className="w-[624px] h-[313px]  object-cover"
      /></div> 
     </div>
     <div className="flex-shrink-0  bg-white w-[574.375px] h-[522.35px] rounded-[47.25px] sm:mx-1 sm:w-[95%] " 
    style={{  
        boxShadow: '14.85px 3.375px 29.7px 9.45px rgba(0, 0, 0, 0.25)' 
    }}>
      <p  className='tracking-wide text-[#959595] flex items-center bg-[#E9F2FF] rounded-t-[2rem] p-5 justify-center sm:text-[12px]'>BUY IN BEFORE PRICE INCREASES!</p>

      <div className='font-inter font-[500] flex gap-[2.5rem] mt-[2rem] items-center justify-center '>
        <div><p className='text-[35px]  sm:text-[22px]'>{timerDays}</p> <p  className='text-[10px] justify-center flex'>DAY</p></div>
        <div><p className='text-[35px] sm:text-[22px]'>{timerHours}</p> <p className='text-[10px] justify-center flex'>HRS</p></div>
        <div><p className='text-[35px] sm:text-[22px]'>{timerMinutes}</p> <p className='text-[10px] justify-center flex'>MINS</p></div>
        <div><p className='text-[35px] sm:text-[22px]'>{timerSeconds}</p> <p className='text-[10px] justify-center flex'>SEC</p></div>
      </div>
      <div >
        <p className='text-[15px] items-center font-inter justify-center mt-[2rem] flex'>1 HMZ = $0.020 USDT</p>
      </div>
      {paymentMethod === 'ETH' ? 
        <div className='flex  items-center font-bold font-inter justify-center mt-[2rem] gap-5 sm:px-[3rem] sm:mx-1 sm:w-[100%] '>

<div onClick={() => setPaymentMethod('ETH')} className='text-white flex gap-3 px-[5rem] py-2 rounded-[47.25px] bg-[#9C02EA] sm:px-[3.5rem]  sm:text-[12px]'> <img
  src={Eth}
  alt="image"
  className="w-3 h-5  object-cover"
/><p>ETH</p></div>
<div onClick={() => setPaymentMethod('USDT')} className='text-white flex gap-3 px-[5rem] py-2 rounded-[47.25px] bg-[#000000] sm:px-[3.5rem]  sm:text-[12px]'> <img
  src={Usdt}
  alt="image"
  className="w-5 h-5 object-cover"
/><p>USDT</p></div>

</div>
:
<div className='flex  items-center font-bold font-inter justify-center mt-[2rem] gap-5 sm:px-[3rem] sm:mx-1 sm:w-[100%] '>

<div onClick={() => setPaymentMethod('ETH')} className='text-white flex gap-3 px-[5rem] py-2 rounded-[47.25px] bg-[#000000] sm:px-[3.5rem]  sm:text-[12px]'> <img
  src={Eth}
  alt="image"
  className="w-3 h-5  object-cover"
/><p>ETH</p></div>
<div onClick={() => setPaymentMethod('USDT')} className='text-white flex gap-3 px-[5rem] py-2 rounded-[47.25px] bg-[#9C02EA] sm:px-[3.5rem]  sm:text-[12px]'> <img
  src={Usdt}
  alt="image"
  className="w-5 h-5 object-cover"
/><p>USDT</p></div>

</div>
    }

      
      
      <div className='flex items-center font-inter justify-center mt-[2rem] gap-5 sm:mx-[9px] sm:w-[95%] sm:gap-1 '>
        <div>
        <div className='flex gap-[7rem] sm:gap-12'><p className='text-[12px] font-inter text-[#959595]  sm:text-[10px]'>Paying with {paymentMethod}</p><p className='text-[12px] font-bold sm:text-[9px]'>MAX</p></div>
        <input  onChange={toReceive} type="number" id="example" placeholder='0' className=' font-night text-xl bg-[#CEFCFF] border bg-transparent rounded-[1rem] h-[3rem] p-2 w-[100%] focus:outline-none focus:border-blue-500 block appearance-none sm:h-[3rem] sm:text-xl' />
        </div>
        <div>
        <p className='text-[12px] font-inter text-[#959595] sm:text-[10px]'>You'll receive</p>
        <input readOnly type="number" id="example" placeholder="0" className="text-[#959595] font-inter text-xl bg-[#CEFCFF] border bg-transparent rounded-[1rem] h-[3rem] p-2 w-[100%] focus:outline-none focus:border-blue-500 block appearance-none sm:h-[3rem] sm:text-xl" value={output} />
        </div>
      </div>
      {isWalletConnected ? <div onClick={buyToken} className='hover:bg-[#9C02EA] hover:text-white hover:border-none hover:cursor-pointer tracking-wide border border-solid border-[#000000] font-inter font-[700] text-bold rounded-xl p-3 flex items-center mx-[2rem] justify-center mt-[2rem]'>BUY</div> 
      : 
      <div onClick={() => open()} className='hover:bg-[#9C02EA] hover:text-white hover:border-none hover:cursor-pointer tracking-wide border border-solid border-[#000000] font-inter font-[700] text-bold rounded-xl p-3 flex items-center mx-[2rem] justify-center mt-[2rem]'>CONNECT WALLET</div>}
      
      <Modal show={showModal} onClose={() => setShowModal(false)}>
                <p>
                     
                    <a href={`${etherscanBaseUrl}${transactionReceipt?.transactionHash}`} 
                       target="_blank" 
                       rel="noopener noreferrer"
                       className="text-blue-500 hover:text-blue-700">
                        View on Etherscan
                    </a>
                </p>
                {/* Other transaction details */}
            </Modal>


     </div>
    </div>
  )
}

export default Container
